import {Component, HostListener, Input, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {BoostrapModalService} from "../../core/services/boostrap-modal/boostrap-modal.service";
import {NgClass, NgIf} from "@angular/common";

@Component({
  selector: 'app-bootstrap-modal',
  standalone: true,
  imports: [
    NgIf,
    NgClass
  ],
  templateUrl: './bootstrap-modal.component.html',
  styleUrl: './bootstrap-modal.component.scss'
})
export class BootstrapModalComponent implements OnInit,OnDestroy {
  @Input() modalId!: string;
  @Input() title: string = 'Modal';
  @Input() size: string = 'md';
  @Input() optionalClasses: string;
  isOpen = false;
  private subscription!: Subscription;


  constructor(private modalService: BoostrapModalService) {}

  ngOnInit() {
    this.subscription = this.modalService.modalState$.subscribe((id) => {
      this.isOpen = id === this.modalId;
    });
  }

  // Close the modal
  closeModal() {
    this.isOpen = false;
  }

  // Listen for ESC key
  @HostListener('document:keydown.escape', ['$event'])
  handleEscape(event: KeyboardEvent) {
    if (this.isOpen) {
      this.closeModal();
      this.modalService.close();
    }
  }

  close() {
    this.modalService.close();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
